import "./AddUpdateDrugOrder.css";
import { useEffect, useRef, useState } from "react";
import Loader from "../../../components/Loader";
import { CreateHandleUnsaveNavigation } from "../../../utilities/handleUnsaveNavigation";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Grid2, TextField } from "@mui/material";
import UncontrolledSearchSelect from "../../../components/UncontrolledSearchSelect";
import { DeleteOutlineOutlined, InfoOutlined } from "@mui/icons-material";
import {
  getDrugOrderOnloadDataService,
  getLotsDataService,
  getLotsDrugDataService,
  getSequenceDrugsDataService,
  placeDrugOrderService,
  validateSequenceRangesService,
} from "../../../services/drugOrderManagementService";
import ReviewDrugOrder from "./ReviewOrder/ReviewDrugOrder";
import {
  groupByUniqueId,
  notifyError,
  notifySuccess,
} from "../../../utilities/helper";
import LotDeleteModal from "../../../components/LotDeleteModal/LotDeleteModal";
import SequenceDeleteModal from "../../../components/SequenceDeleteModal/SequenceDeleteModal";
import LotDrugTable from "../../../components/LotDrugTable/LotDrugTable";
import SequenceDrugContainer from "../../../components/SequenceDrugContainer/SequenceDrugContainer";
import SequenceOverlapModal from "../../../components/SequenceOverlapModal/SequenceOverlapModal";
import OrderConfirmation from "./OrderConfirmation/OrderConfirmation";
import LotOverlapModal from "../../../components/LotOverlapModal/LotOverlapModal";
import ValidSequenceRangeModal from "../../../components/ValidSequenceRangeModal/ValidSequenceRangeModal";

const AddUpdateDrugOrder = () => {
  const id = useLocation().state?.id;

  const [load, setLoad] = useState(false);
  const [orderType, setOrderType] = useState("depotToDepot");
  const [fromDepotName, setFromDepotName] = useState(
    <i style={{ fontSize: "small", color: "grey" }}>Select To Depot First</i>
  );
  const [fromDepotId, setFromDepotId] = useState(null);
  const [selectionType, setSelectionType] = useState("");
  const [fromDepotData, setFromDepotData] = useState([]);
  const [toDepotData, setToDepotData] = useState([]);
  const [fromDepot, setFromDepot] = useState("");
  const [toDepot, setToDepot] = useState("");
  const [toSite, setToSite] = useState("");
  const [siteLookUpSiteData, setSiteLookUpSiteData] = useState([]);
  const [toSiteData, setToSiteData] = useState([]);
  const [drugList, setDrugList] = useState([]);
  const [sequenceDrugList, setSequenceDrugList] = useState([]);
  const [lotData, setLotData] = useState([]);
  const [selectedLot, setSelectedLot] = useState("");
  const [lotDrugCart, setLotDrugCart] = useState([]);
  const [addedToLotCart, setAddedToLotCart] = useState(false);
  const [showLotCartDeleteModal, setShowLotCartDeleteModal] = useState(false);
  const [sequenceDrugCart, setSequenceDrugCart] = useState([]);
  const [addedToSequenceCart, setAddedToSequenceCart] = useState(false);
  const [showSequenceCartDeleteModal, setShowSequenceCartDeleteModal] =
    useState(false);
  const [sequenceDeleteItem, setSequenceDeletedItem] = useState(null);
  const [reviewOrderConfirm, setReviewOrderConfirm] = useState(false);
  const [uniqueLotData, setUniqueLotData] = useState([]);
  const [lotDrugDeleteId, setLotDrugDeleteId] = useState(null);
  const [showSequenceOverlapModal, setShowSequenceOverlapModal] =
    useState(false);
  const [showDrugOrderConfirmation, setShowDrugOrderConfirmation] =
    useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const [showLotOverlapModal, setShowLotOverlapModal] = useState(false);
  const [lotOverLapData, setLotOverLapData] = useState([]); // Data for lot overlap modal
  const [showValidaRangeModal, setShowValidRangeModal] = useState(false);

  const sequenceRefs = useRef({});

  // Track quantities separately by ID
  const [quantities, setQuantities] = useState({});

  const [rangeInputs, setRangeInputs] = useState({});
  const [openAccordionId, setOpenAccordionId] = useState(null);

  const access_token = localStorage?.getItem("access_token");
  const roleId = localStorage.getItem("roleId");

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();

  const navigate = useNavigate();

  const drugOrderCreateSchema = yup.object().shape({
    fromDepot: yup.string().required("From Depot is required"),
    toDepot: yup.string().required("To Depot is required"),
    toSite: yup.string().required("To Site is required"),
    orderType: yup.string().required("Order Type is required"),
    selectionType: yup.string().required("Selection Type is required"),
    selectedLot: yup.string().required("Lot is required"),
  });

  const {
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(drugOrderCreateSchema),
    defaultValues: {
      fromDepot: "",
      toDepot: "",
      orderType: "",
      toSite: "",
      selectionType: "",
      selectedLot: "",
    },
  });

  useEffect(() => {
    if (access_token && roleId) getOnLoadData();
  }, [access_token, roleId]);

  useEffect(() => {
    if (selectionType === "lot") {
      if (fromDepot && toDepot) {
        getLotData(fromDepot);
      } else if (toSite && fromDepotId) {
        getLotData("", toSite);
      }
    }
  }, [fromDepot, toDepot, fromDepotId, toSite, selectionType]);

  useEffect(() => {
    if (selectionType === "lot") {
      if (selectedLot && access_token && fromDepot) {
        getLotDrugData(selectedLot, fromDepot);
      } else if (selectedLot && access_token && toSite) {
        getLotDrugData(selectedLot, "", toSite);
      }
    }
  }, [fromDepot, selectedLot, access_token, roleId, selectionType]);

  useEffect(() => {
    if (access_token && fromDepot && selectionType === "sequence") {
      getSequenceDrugData(fromDepot);
    } else if (
      access_token &&
      toSite &&
      fromDepotId &&
      selectionType === "sequence"
    ) {
      getSequenceDrugData("", toSite);
    }
  }, [fromDepot, access_token, selectionType, toSite, fromDepotId]);

  useEffect(() => {
    if (orderType) {
      resetDetails();
    }
  }, [orderType]);

  useEffect(() => {
    if (fromDepot !== "" || toDepot !== "") {
      setSelectedLot("");
      setQuantities({});
      setSelectionType("");
      setLotDrugCart([]);
      setRangeInputs({});
      setSequenceDrugCart([]);
      setAddedToLotCart(false);
      setAddedToSequenceCart(false);
    }
  }, [fromDepot, toDepot]);

  useEffect(() => {
    if (selectionType) {
      setSelectedLot("");
      setQuantities({});
      setLotDrugCart([]);
      setRangeInputs({});
      setSequenceDrugCart([]);
    }
  }, [selectionType]);

  useEffect(() => {
    if (lotDrugCart && lotDrugCart?.length > 0) {
      setUniqueLotData(groupByUniqueId(lotDrugCart));
    }
  }, [lotDrugCart]);

  const resetDetails = () => {
    setFromDepot("");
    setToDepot("");
    setSelectedLot("");
    setToSite("");
    setFromDepotId(null);
    setFromDepotName("");
    setQuantities({});
    setSelectionType("");
    setLotDrugCart([]);
    setRangeInputs({});
    setSequenceDrugCart([]);
    setAddedToLotCart(false);
    setAddedToSequenceCart(false);
  };

  const getOnLoadData = async () => {
    try {
      setLoad(true);
      const res = await getDrugOrderOnloadDataService(access_token, "", roleId);

      if (res?.status == 200) {
        setLoad(false);
        const depotData = res?.data?.result?.depots;
        setFromDepotData(depotData);
        setToDepotData(depotData);
        setToSiteData(res?.data?.result?.sites);
        setSiteLookUpSiteData(res?.data?.result?.siteDepotLookup);
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message || "Error in Fetching Data");
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const getLotData = async (fromDepot = "", toSite = "") => {
    try {
      setLoad(true);
      const res = await getLotsDataService(access_token, fromDepot, toSite);
      if (res?.data?.status == 200) {
        setLoad(false);
        setLotData(res?.data?.result);
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message || "Error in Fetching Data");
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const getLotDrugData = async (selectedLot, depotId = "", siteId = "") => {
    try {
      setLoad(true);
      const res = await getLotsDrugDataService(
        access_token,
        selectedLot,
        depotId,
        siteId
      );
      if (res?.status == 200) {
        setLoad(false);
        const apiData = res?.data?.result;

        setDrugList(apiData);

        // Initialize quantities
        const initialQuantities = {};
        apiData.forEach((drug) => {
          initialQuantities[drug.drugTypeId] = 0;
        });
        setQuantities(initialQuantities);
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message || "Error in Fetching Data");
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const getSequenceDrugData = async (depotId = "", siteId = "") => {
    try {
      setLoad(true);
      const res = await getSequenceDrugsDataService(
        access_token,
        depotId,
        siteId
      );
      if (res?.status == 200) {
        setLoad(false);
        const data = res?.data?.result;
        setSequenceDrugList(data);

        const initialState = {};
        data?.forEach((drug) => {
          initialState[drug.drugTypeId] = { from: "", to: "", ordered: 0 };
        });
        setRangeInputs(initialState);
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message || "Error in Fetching Data");
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const validateSequenceRange = async (data) => {
    setLoad(true);
    try {
      const res = await validateSequenceRangesService(access_token, data);
      if (res?.data?.status == 200) {
        setLoad(false);
        return res?.data?.result?.availableDrugsCount;
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message || "Error in Validating Sequence Range");
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  // Function for checking valid quantity is entered or not
  const isAnyQuantityInvalid = drugList?.some((drug) => {
    const allZero = Object.values(quantities).every((qty) => Number(qty) == 0);

    if (allZero) return true;

    const qty = quantities[drug.drugTypeId];
    const numQty = Number(qty);

    return (
      qty === undefined || // not set at all
      qty === "" || // empty string
      isNaN(numQty) || // not a number
      numQty < 0 || // zero or negative
      numQty > drug.availableQuantity // exceeds available
    );
  });

  const handleQuantityChange = (id, value) => {
    if (/^\d*$/.test(value)) {
      setQuantities((prev) => {
        const updatedQuantities = {
          ...prev,
          [id]: value,
        };
        return updatedQuantities;
      });
    }
  };

  const handleLotDrugCart = () => {
    const uniqueId = `${Date.now()}_${Math.floor(Math.random() * 10000)}`;

    const invalidItems = [];
    const validItems = [];

    drugList
      ?.filter(
        (drug) =>
          quantities[drug.drugTypeId] != null &&
          Number(quantities[drug.drugTypeId]) > 0
      )
      .forEach((drug) => {
        const enteredQty = Number(quantities[drug.drugTypeId]);

        // Find if this drug already exists in the cart for the same lot
        const existingQty = (lotDrugCart || [])
          .filter(
            (item) => item.id === drug.drugTypeId && item.lotId === selectedLot
          )
          .reduce((sum, item) => sum + item.quantity, 0);

        const totalQty = existingQty + enteredQty;

        if (totalQty > drug.availableQuantity) {
          invalidItems.push(
            `${drug.drugName} (Available: ${drug.availableQuantity}, Already added: ${existingQty}, Tried: ${enteredQty})`
          );
        } else {
          validItems.push({
            id: drug.drugTypeId,
            uniqueId: uniqueId,
            name: drug.drugName,
            quantity: enteredQty,
            availableQuantity: drug.availableQuantity,
            lot: drug?.lot,
            lotName: lotData?.find((lot) => lot?.key === selectedLot)?.value,
            lotId: selectedLot,
          });
        }
      });

    // Show one combined alert if there are invalid items
    if (invalidItems.length > 0) {
      setShowLotOverlapModal(true);
      setLotOverLapData(invalidItems); // Set data for lot overlap modal
    }

    // Add only valid items
    if (validItems.length > 0) {
      setLotDrugCart((prevCart) => [...(prevCart || []), ...validItems]);
      setAddedToLotCart(true);
      setSelectedLot("");
      setQuantities({});
    }
  };

  // const handleInputChange = (id, field, value, sequenceRangeLow, high) => {
  //   if (/^\d*$/.test(value)) {
  //     setRangeInputs(async (prev) => {
  //       const updated = {
  //         ...prev[id],
  //         [field]: value,
  //       };

  //       const from = Number(updated.from);
  //       const to = Number(updated.to);
  //       let ordered = 0;
  //       if (from < sequenceRangeLow || to > high) {
  //         ordered = 0; // Reset ordered if out of range
  //       } else {
  //         // ordered = from && to && to >= from ? to - from + 1 : 0;
  //         const validateData = {
  //           drugTypeId: id,
  //           minRange: from,
  //           maxRange: to,
  //         };
  //         if (from && to && to >= from) {
  //           const numOfDrugs = await validateSequenceRange(validateData);
  //           if (numOfDrugs > 0) {
  //             ordered = numOfDrugs;
  //           } else {
  //             ordered = 0;
  //           }
  //         }
  //       }

  //       return {
  //         ...prev,
  //         [id]: { ...updated, ordered },
  //       };
  //     });
  //   }
  // };

  const handleInputChange = (id, field, value, sequenceRangeLow, high) => {
    if (/^\d*$/.test(value)) {
      setRangeInputs((prev) => {
        const updated = {
          ...prev[id],
          [field]: value,
        };

        return {
          ...prev,
          [id]: { ...updated },
        };
      });

      const updatedFrom =
        field === "from" ? Number(value) : Number(rangeInputs[id]?.from || 0);
      const updatedTo =
        field === "to" ? Number(value) : Number(rangeInputs[id]?.to || 0);

      if (
        updatedFrom >= sequenceRangeLow &&
        updatedTo <= high &&
        updatedFrom > 0 &&
        updatedTo > 0 &&
        updatedTo >= updatedFrom
      ) {
        validateSequenceRange({
          drugTypeId: id,
          minRange: updatedFrom,
          maxRange: updatedTo,
        }).then((numOfDrugs) => {
          setRangeInputs((prev) => ({
            ...prev,
            [id]: {
              ...prev[id],
              ordered: numOfDrugs > 0 ? numOfDrugs : 0,
            },
          }));

          // 👇 Scroll only the row that was updated
          setTimeout(() => {
            sequenceRefs.current[id]?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            sequenceRefs.current[id]?.querySelector("input")?.focus();
          }, 0);
        });
      }
    }
  };

  const toggleAccordion = (id) => {
    setOpenAccordionId((prev) => (prev === id ? null : id));
  };

  const handleAddToOrder = async (id, type) => {
    const { from, to, ordered } = rangeInputs[id];

    // Check if the new range overlaps with any existing range
    const isOverlapping = sequenceDrugCart.some(
      (item) =>
        item.id === id &&
        item.type === type &&
        // case 1: new range starts inside an existing range
        ((from >= item.from && from <= item.to) ||
          // case 2: new range ends inside an existing range
          (to >= item.from && to <= item.to) ||
          // case 3: new range fully covers an existing range
          (from <= item.from && to >= item.to))
    );

    if (isOverlapping) {
      setShowSequenceOverlapModal(true);
      return;
    }

    const validateData = {
      drugTypeId: id,
      minRange: from,
      maxRange: to,
    };

    const numOfDrugs = await validateSequenceRange(validateData);

    if (numOfDrugs > 0) {
      const uniqueId = `${Date.now()}_${Math.floor(Math.random() * 10000)}`;

      setSequenceDrugCart((prev) => [
        ...prev,
        { id, type, from, to, ordered: numOfDrugs, uniqueId },
      ]);
      setAddedToSequenceCart(true);
      setShowValidRangeModal(false);
      setRangeInputs((prev) => ({
        ...prev,
        [id]: { from: "", to: "", ordered: 0 }, // Reset inputs after adding
      }));
    } else {
      setShowValidRangeModal(true);
    }
  };

  const handleSequenceCartDelete = () => {
    const uniqueId = sequenceDeleteItem?.uniqueId;
    let filteredItem = sequenceDrugCart?.filter(
      (item) => item?.uniqueId != uniqueId
    );
    setSequenceDrugCart(filteredItem);
    setShowSequenceCartDeleteModal(false);
    setSequenceDeletedItem(null);
  };

  const submitOrderType = () => {
    setReviewOrderConfirm(true);
  };

  const submitOrder = async () => {
    const isLotBased = lotDrugCart?.length > 0;

    const tempData = (isLotBased ? lotDrugCart : sequenceDrugCart)?.map(
      (item) =>
        isLotBased
          ? {
              drugName: item?.name,
              drugTypeId: item?.id,
              quantity: item?.quantity,
              availableQuantity: item?.availableQuantity,
              lotId: item?.lotId,
              lot: item?.lot,
              lotName: item?.lotName,
            }
          : {
              selectedSequenceRangeHigh: item?.to,
              selectedSequenceRangeLow: item?.from,
              availableQuantity: item?.ordered,
              drugTypeId: item?.id,
              drugType: { name: item?.type },
              drugName: item?.type,
            }
    );

    const dynamicKey = isLotBased ? "lots" : "sequenceRanges";

    const data = {
      orderType: orderType === "depotToDepot" ? "DepotToDepot" : "DepotToSite",
      sourceDepotId: orderType === "depotToDepot" ? fromDepot : fromDepotId,
      destinationDepotId: toDepot,
      destinationSiteId: toSite,
      drugOrderSelectionType: isLotBased ? 0 : 1,
      [dynamicKey]: tempData,
    };

    try {
      setLoad(true);
      const res = await placeDrugOrderService(access_token, data);
      if (res?.data?.status == 201) {
        setLoad(false);
        notifySuccess("Drug Order Placed Successfully !");
        setShowDrugOrderConfirmation(true);
        setConfirmationData(res?.data?.result);
        setReviewOrderConfirm(false);
        // navigate("/drug-shipment-management");
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.message);
      console.log("Error :", err);
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  return (
    <>
      {reviewOrderConfirm ? (
        <ReviewDrugOrder
          setReviewOrderConfirm={setReviewOrderConfirm}
          data={lotDrugCart?.length > 0 ? uniqueLotData : sequenceDrugCart}
          destinationDepot={
            fromDepotData?.find((item) => item?.id === toDepot)?.name
          }
          orderType={
            orderType === "depotToDepot" ? "Depot To Depot" : "Depot To Site"
          }
          sourceDepot={
            orderType === "depotToDepot"
              ? fromDepotData?.find((item) => item?.id === fromDepot)?.name
              : siteLookUpSiteData?.find((item) => item?.id === fromDepotId)
                  ?.depotName
          }
          type={lotDrugCart?.length > 0 ? "Lots" : "Sequence"}
          submitOrder={submitOrder}
          destinationSite={
            toSiteData?.find((item) => item?.id === toSite)?.name
          }
          load={load}
        />
      ) : (
        <>
          {showDrugOrderConfirmation ? (
            <OrderConfirmation
              data={confirmationData}
              setShowConfirm={setShowDrugOrderConfirmation}
              resetDetails={resetDetails}
            ></OrderConfirmation>
          ) : (
            <>
              {load ? (
                <Loader />
              ) : (
                <div className="content-body">
                  <p className="bread-crumbs-link-container">
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnsaveNavigation(e, isDirty, "", navigate)
                      }
                    >
                      Home
                    </button>{" "}
                    |{" "}
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "drug-shipment-management",
                          navigate
                        )
                      }
                    >
                      Drug Order Management
                    </button>{" "}
                    |{" "}
                    <button
                      className="bread-crumbs-btn"
                      to="/addUpdate-drug-order"
                    >
                      {id ? "Edit Drug Order" : "Place Drug Order"}
                    </button>
                    -{" "}
                    <b style={{ color: "gray" }}>
                      {localStorage?.getItem("studyName")}
                    </b>
                  </p>
                  <Grid2
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ width: "100%", margin: "0 auto" }}
                  >
                    <Grid2 item md={12}>
                      <p className="page-heading">Place Order</p>
                    </Grid2>
                  </Grid2>

                  <Box
                    component="form"
                    autoComplete="off"
                    sx={{ height: "auto", width: "100%" }}
                    onSubmit={handleSubmit(() => {})}
                  >
                    <Grid2
                      container
                      alignItems="center"
                      justifyContent={"space-between"}
                      sx={{
                        width: "100%",
                        margin: "0 auto",
                      }}
                      gap={1}
                    >
                      <div className="order-type-container">
                        <Grid2
                          size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}
                        >
                          <div>
                            <p className="labelStyles">
                              Order Type
                              <span>*</span>
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "15px",
                              justifyContent: "start",
                            }}
                          >
                            <button
                              type="button"
                              className={
                                orderType == "depotToDepot"
                                  ? "create-btn"
                                  : "create-btn-outlined"
                              }
                              onClick={() => setOrderType("depotToDepot")}
                            >
                              Depot to Depot
                            </button>
                            <button
                              type="button"
                              className={
                                orderType === "depotToSite"
                                  ? "create-btn"
                                  : "create-btn-outlined"
                              }
                              onClick={() => setOrderType("depotToSite")}
                            >
                              Depot to Site
                            </button>
                          </div>
                        </Grid2>
                        {orderType !== "" && (
                          <>
                            <Grid2
                              size={{ xl: 6, md: 6, lg: 6, sm: 12, xs: 12 }}
                              sx={{
                                marginTop: "20px",
                                marginBottom: "20px",
                              }}
                            >
                              {orderType === "depotToDepot" ? (
                                <>
                                  <div className="order-ddl-container">
                                    <div className="order-ddl-label">
                                      From Depot{" "}
                                      <span className="font-red">*</span>
                                    </div>
                                    <UncontrolledSearchSelect
                                      data={fromDepotData}
                                      name={"fromDepot"}
                                      optionKey="id"
                                      value={fromDepot}
                                      onChange={(selectedValue) => {
                                        setFromDepot(selectedValue);
                                      }}
                                      optionLabel="name"
                                    />
                                  </div>
                                  {errors.fromDepot && (
                                    <div className="error-container">
                                      {errors.fromDepot.message}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  <div
                                    className="order-ddl-container"
                                    style={{
                                      margin: "10px 0px",
                                    }}
                                  >
                                    <div className="order-ddl-label">
                                      From Depot{" "}
                                      <span className="font-red">*</span>
                                    </div>
                                    <span className="from-depot-name">
                                      {fromDepotName}
                                    </span>
                                  </div>
                                </>
                              )}
                            </Grid2>
                            {orderType === "depotToDepot" ? (
                              <Grid2
                                size={{ xl: 6, md: 6, lg: 6, sm: 12, xs: 12 }}
                                sx={{
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <div className="order-ddl-container">
                                  <div className="order-ddl-label">
                                    To Depot <span className="font-red">*</span>
                                  </div>
                                  <UncontrolledSearchSelect
                                    data={toDepotData}
                                    name={"toDepot"}
                                    optionKey="id"
                                    optionLabel="name"
                                    onChange={(selectedValue) => {
                                      setToDepot(selectedValue);
                                    }}
                                    value={toDepot}
                                  />
                                </div>
                                {errors.toDepot && (
                                  <div className="error-container">
                                    {errors.toDepot.message}
                                  </div>
                                )}
                              </Grid2>
                            ) : (
                              <Grid2
                                size={{ xl: 6, md: 6, lg: 6, sm: 12, xs: 12 }}
                                sx={{
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <div className="order-ddl-container">
                                  <div className="order-ddl-label">
                                    To Site <span className="font-red">*</span>
                                  </div>
                                  <UncontrolledSearchSelect
                                    data={toSiteData || []}
                                    name={"toSite"}
                                    optionKey="id"
                                    optionLabel="name"
                                    onChange={(selectedValue) => {
                                      const selectedItem =
                                        siteLookUpSiteData?.find(
                                          (item) => item?.id === selectedValue
                                        );
                                      setFromDepotName(selectedItem?.depotName);
                                      setFromDepotId(selectedItem?.id);
                                      setToSite(selectedValue);
                                    }}
                                    value={toSite}
                                  />
                                </div>
                                {errors.toSite && (
                                  <div className="error-container">
                                    {errors.toSite.message}
                                  </div>
                                )}
                              </Grid2>
                            )}
                          </>
                        )}
                      </div>
                    </Grid2>

                    {((toDepot !== "" && fromDepot !== "") ||
                      (toSite !== "" && fromDepotId !== null)) && (
                      <div className="selection-container">
                        {((toDepot !== "" && fromDepot !== "") ||
                          (toSite !== "" && fromDepotId !== null)) && (
                          <Grid2
                            size={{
                              xl: 12,
                              md: 12,
                              lg: 12,
                              sm: 12,
                              xs: 12,
                            }}
                            sx={{ marginBottom: "10px" }}
                          >
                            <div>
                              <p className="labelStyles">
                                Selection Type
                                <span>*</span>
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "start",
                              }}
                            >
                              <button
                                type="button"
                                className={
                                  selectionType == "lot"
                                    ? "create-btn"
                                    : "create-btn-outlined"
                                }
                                onClick={() => setSelectionType("lot")}
                              >
                                Lot
                              </button>
                              <button
                                type="button"
                                className={
                                  selectionType === "sequence"
                                    ? "create-btn"
                                    : "create-btn-outlined"
                                }
                                onClick={() => setSelectionType("sequence")}
                              >
                                Sequence
                              </button>
                            </div>
                          </Grid2>
                        )}

                        {selectionType === "lot" ||
                        selectionType === "sequence" ? (
                          <Grid2
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{
                              width: "100%",
                              margin: "1% auto -2% auto",
                            }}
                          >
                            <Grid2 item md={12}>
                              <p className="page-heading">Add To Order</p>
                            </Grid2>
                          </Grid2>
                        ) : null}

                        {selectionType === "lot" && (
                          <Grid2
                            container
                            // alignItems="center"
                            justifyContent={"space-between"}
                            sx={{ width: "100%", margin: "0 auto 20px 0" }}
                            gap={1}
                          >
                            <Grid2
                              size={{ xl: 6, md: 6, lg: 6, sm: 12, xs: 12 }}
                            >
                              <div>
                                <p className="labelStyles">
                                  Select a Lot
                                  <span>*</span>
                                </p>
                                <UncontrolledSearchSelect
                                  data={lotData || []}
                                  name={"selectedLot"}
                                  optionKey="key"
                                  optionLabel="value"
                                  value={selectedLot}
                                  onChange={(selectedValue) => {
                                    setSelectedLot(selectedValue);
                                  }}
                                />
                              </div>
                              {errors.selectedLot && (
                                <div className="error-container">
                                  {errors.selectedLot.message}
                                </div>
                              )}
                            </Grid2>
                            {lotDrugCart &&
                              lotDrugCart.length > 0 &&
                              addedToLotCart && (
                                <Grid2
                                  size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}
                                  className="border-radius"
                                >
                                  <div className="drug-cart-container">
                                    {uniqueLotData &&
                                      uniqueLotData.length > 0 &&
                                      uniqueLotData?.map((drug) => (
                                        <div
                                          key={drug.uniqueId}
                                          className="border-radius-margin-bottom"
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "baseline",
                                            }}
                                          >
                                            <h3
                                              style={{
                                                margin: "10px",
                                                marginTop: "0px",
                                              }}
                                            >
                                              {drug?.lotName}
                                            </h3>
                                            <button
                                              type="button"
                                              className="grid-edit-btn"
                                              style={{ background: "red" }}
                                              onClick={() => {
                                                setShowLotCartDeleteModal(true);
                                                setLotDrugDeleteId(
                                                  drug?.uniqueId
                                                );
                                              }}
                                            >
                                              <DeleteOutlineOutlined
                                                sx={{ color: "white" }}
                                              />
                                            </button>
                                          </div>
                                          {drug?.quantity?.map(
                                            (item, index) => (
                                              <div
                                                key={index}
                                                style={{ margin: "10px" }}
                                              >
                                                <span>{item.name}</span> -{" "}
                                                <span>{item.quantity}</span>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      ))}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="create-btn"
                                      onClick={submitOrderType}
                                    >
                                      Review Order
                                    </button>
                                  </div>
                                </Grid2>
                              )}
                            {selectionType === "lot" && selectedLot !== "" && (
                              // !addedToLotCart &&
                              // <Grid2 size={{ xl: 4, md: 4, lg: 4, sm: 4, xs: 4 }}>
                              <div className="lot-order-button-container">
                                <button
                                  disabled={
                                    isAnyQuantityInvalid
                                    // || addedToLotCart
                                  }
                                  onClick={() => {
                                    handleLotDrugCart();
                                  }}
                                  type="button"
                                  className={
                                    isAnyQuantityInvalid
                                      ? // || addedToLotCart
                                        "create-btn-outlined disabled"
                                      : "create-btn-outlined"
                                  }
                                >
                                  Add to Order
                                </button>
                              </div>
                              // </Grid2>
                            )}
                          </Grid2>
                        )}

                        <>
                          {selectionType === "lot" &&
                          selectedLot !== "" &&
                          drugList &&
                          drugList?.length > 0 ? (
                            // &&
                            // !addedToLotCart
                            <LotDrugTable
                              drugList={drugList}
                              handleQuantityChange={handleQuantityChange}
                              quantities={quantities}
                            />
                          ) : (
                            <>
                              {selectionType === "lot" &&
                              selectedLot !== "" &&
                              drugList?.length == 0 ? (
                                <div>
                                  <h5>No Drugs Found</h5>
                                </div>
                              ) : null}
                            </>
                          )}
                        </>

                        {selectionType === "sequence" && (
                          <p
                            className="page-sub-header"
                            style={{ width: "66%" }}
                          >
                            <InfoOutlined className="info-icon" />
                            IRT system will not check that all kits are in the
                            same label group when ordering by sequence range.
                          </p>
                        )}

                        <div className="sequence-main-container">
                          {selectionType === "sequence" ? (
                            <>
                              {sequenceDrugList &&
                              sequenceDrugList?.length > 0 ? (
                                <div className="drug-sequence-order-container">
                                  {sequenceDrugList?.map((drug) => {
                                    const input =
                                      rangeInputs[drug.drugTypeId] || {};
                                    const isDisabled =
                                      !input.from ||
                                      !input.to ||
                                      Number(input.to) < Number(input.from) ||
                                      Number(input.from) <
                                        Number(drug.sequenceRangeLow) ||
                                      Number(input.to) >
                                        Number(drug.sequenceRangeHigh);

                                    return (
                                      <div
                                        key={drug.drugTypeId}
                                        ref={(el) =>
                                          (sequenceRefs.current[
                                            drug.drugTypeId
                                          ] = el)
                                        }
                                      >
                                        <SequenceDrugContainer
                                          drug={drug}
                                          handleAddToOrder={handleAddToOrder}
                                          handleInputChange={handleInputChange}
                                          input={input}
                                          isDisabled={isDisabled}
                                          openAccordionId={openAccordionId}
                                          toggleAccordion={toggleAccordion}
                                          key={drug?.drugTypeId}
                                          sequenceDrugList={sequenceDrugList}
                                        />
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <h4
                                  style={{
                                    color: "gray",
                                  }}
                                >
                                  No Drugs Available For Selected Combination
                                </h4>
                              )}
                            </>
                          ) : null}
                          {sequenceDrugCart &&
                            sequenceDrugCart?.length > 0 &&
                            addedToSequenceCart && (
                              <div className="sequence-cart-main-container">
                                <div className="sequence-drug-cart-container">
                                  {sequenceDrugCart &&
                                    sequenceDrugCart?.map((item, index) => (
                                      <div
                                        className="sequence-drug-cart-item"
                                        key={index}
                                      >
                                        <div className="sequence-drug-cart-name-container">
                                          {item?.type}
                                          <div className="sequence-drug-cart-name-item">
                                            Range : {item?.from} - {item?.to}
                                          </div>
                                        </div>
                                        <div className="sequence-drug-cart-qty-del-container">
                                          <h3>
                                            <i>Qty</i>. {item?.ordered}
                                          </h3>
                                          <button
                                            type="button"
                                            className="grid-edit-btn"
                                            style={{ background: "red" }}
                                            onClick={() => {
                                              setSequenceDeletedItem(item);
                                              setShowSequenceCartDeleteModal(
                                                true
                                              );
                                            }}
                                          >
                                            <DeleteOutlineOutlined
                                              sx={{ color: "white" }}
                                            />
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                                <div className="sequence-review-container">
                                  <button
                                    type="button"
                                    className="create-btn"
                                    onClick={submitOrderType}
                                  >
                                    Review Order
                                  </button>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </Box>
                </div>
              )}
              {showLotCartDeleteModal && (
                <LotDeleteModal
                  lotDrugCart={lotDrugCart}
                  lotDrugDeleteId={lotDrugDeleteId}
                  setLotDrugCart={setLotDrugCart}
                  setLotDrugDeleteId={setLotDrugDeleteId}
                  setShowLotCartDeleteModal={setShowLotCartDeleteModal}
                  showLotCartDeleteModal={showLotCartDeleteModal}
                />
              )}
              {showSequenceCartDeleteModal && (
                <SequenceDeleteModal
                  showSequenceCartDeleteModal={showSequenceCartDeleteModal}
                  setShowSequenceCartDeleteModal={
                    setShowSequenceCartDeleteModal
                  }
                  sequenceDeleteItem={sequenceDeleteItem}
                  setSequenceDeletedItem={setSequenceDeletedItem}
                  handleSequenceCartDelete={handleSequenceCartDelete}
                />
              )}
              {showSequenceOverlapModal && (
                <SequenceOverlapModal
                  showSequenceOverlapModal={showSequenceOverlapModal}
                  setShowSequenceOverlapModal={setShowSequenceOverlapModal}
                />
              )}
              {showLotOverlapModal && (
                <LotOverlapModal
                  showLotOverlapModal={showLotOverlapModal}
                  setShowLotOverlapModal={setShowLotOverlapModal}
                  data={lotOverLapData}
                />
              )}

              {showValidaRangeModal && (
                <ValidSequenceRangeModal
                  setShowValidRangeModal={setShowValidRangeModal}
                  showValidRangeModal={showValidaRangeModal}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default AddUpdateDrugOrder;
